import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { IPropertyRentTermModel } from '../../shared/models/PropertyRentTermModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { ToastService } from '../../shared/providers/toast.service';

@Component({
  selector: 'app-edit-rent-term-table',
  templateUrl: './edit-rent-term-table.component.html',  
})
export class EditRentTermTableComponent implements OnInit {
    @Output() save = new EventEmitter();
    @Output() close = new EventEmitter();
    @Input() currentRentTermDetails: IPropertyRentTermModel;
    @Input() PropertyRentTerm: IPropertyRentTermModel[];
    isValidDate: boolean = true;
    isValidIncrease: boolean = true;
    rentTermDetails = {} as IPropertyRentTermModel;
    Years: string;
    LeaseStartDate: Date | null;
    LeaseEndDate: Date | null;
    NetOperatingIncome: number;
    Increase: number;
    IsOptional?: boolean;
    IsStartDateValid?= false as boolean;
    IsEndDateValid?= false as boolean;
    IsValidNetOperatingIncome = false as boolean;
    IsValidYears = false as boolean;
    Commencement: Date | null;    
    LeaseExpiration: Date | null;
    LeaseCommencementDate: Date | null;
    IsIncreaseAutoCalc: boolean;

    constructor(public validationService: ValidationService, private Toast: ToastService,) { }

    ngOnInit() {
        
        this.Years = this.currentRentTermDetails.Years
        this.LeaseStartDate = this.currentRentTermDetails.LeaseStartDate
        this.LeaseEndDate = this.currentRentTermDetails.LeaseEndDate
        this.NetOperatingIncome = this.currentRentTermDetails.NetOperatingIncome
        this.Increase = this.currentRentTermDetails.Increase
        this.IsOptional = this.currentRentTermDetails.IsOptional;
        this.LeaseExpiration = this.currentRentTermDetails.LeaseExpiration;
        this.LeaseCommencementDate = this.currentRentTermDetails.LeaseCommencementDate;
        this.IsIncreaseAutoCalc = this.currentRentTermDetails.IsIncreaseAutoCalc;
    }
    onClose($event) {
        this.close.emit();
    }
    saveSalesDetails() {
        if (this.checkFormValidation()) {
        this.rentTermDetails.Years = this.Years; //this.LeaseStartDate.getFullYear() + ' - ' + this.LeaseStartDate.getFullYear() + (this.currentRentTermDetails.OptionNumber > 0 ? "Option " + this.currentRentTermDetails.OptionNumber : "");
        this.rentTermDetails.LeaseStartDate = this.LeaseStartDate;
        this.rentTermDetails.LeaseEndDate = this.LeaseEndDate;
        this.rentTermDetails.NetOperatingIncome = this.NetOperatingIncome;
            this.rentTermDetails.Increase = this.Increase > 0 ? this.Increase : 0;
            this.rentTermDetails.IsOptional = this.IsOptional == null ? (this.LeaseExpiration < this.LeaseStartDate ? true : false) : this.IsOptional;
        this.rentTermDetails.Id = this.currentRentTermDetails.Id;
            this.rentTermDetails.OptionNumber = this.currentRentTermDetails.OptionNumber;
            this.rentTermDetails.IsIncreaseAutoCalc = this.IsIncreaseAutoCalc;
        this.save.emit(this.rentTermDetails);
        }
    }
    validateDate(date) {
        var isDate = this.validationService.IsDate(date);
        if (isDate == false && date != null) {
            return this.isValidDate = true;
        }
        else {
            return this.isValidDate = false;
        }
    }
    validatePercentage(Increase) {
        if (Increase > 100 || Increase < 0) {
            this.isValidIncrease = false;
        }
        else {
            this.isValidIncrease = true;
        }
    }

    calcIncreasePercent(NetOperatingIncome) {
        this.netOperatingIncomeValidate(NetOperatingIncome)
        if (this.currentRentTermDetails.Id > 0 && this.IsIncreaseAutoCalc) {
            let previousNetOperatingIncome = this.PropertyRentTerm[this.currentRentTermDetails.Id - 1].NetOperatingIncome;
            this.Increase = NetOperatingIncome - previousNetOperatingIncome > 0 ? Math.round(((NetOperatingIncome - previousNetOperatingIncome) * 100 / previousNetOperatingIncome) * 100) / 100 : 0;
        }
    }

    calcNOIBasedOnPercent(IsIncreaseAutoCalc) {
        if (this.currentRentTermDetails.Id > 0 && IsIncreaseAutoCalc) {
            let previousNetOperatingIncome = this.PropertyRentTerm[this.currentRentTermDetails.Id - 1].NetOperatingIncome;
            this.Increase = this.NetOperatingIncome - previousNetOperatingIncome > 0 ? Math.round(((this.NetOperatingIncome - previousNetOperatingIncome) * 100 / previousNetOperatingIncome) * 100) / 100: 0;
        }
    }

    dateOverlapValidation(date, dateType) {
        let status = true;
        let toastMsg = "";
        let overlapingRows = [];
        if (!this.validationService.IsDate(date)) {
            if (dateType == 1) {
                this.IsStartDateValid = true;
            }
            else if (dateType == 2) {
                this.IsEndDateValid = true;
            }

        }
        else {
            for (let i = this.currentRentTermDetails.Id + 1; i < this.PropertyRentTerm.length; i++) {
                if (date > this.PropertyRentTerm[i].LeaseStartDate || date > this.PropertyRentTerm[i].LeaseEndDate) {
                    status = false;
                    overlapingRows.push(i + 1);
                }

                if (dateType == 1) //start date
                {
                    toastMsg = 'Start Date';
                    this.IsStartDateValid = !status;
                }
                else {
                    this.IsEndDateValid = !status;
                    toastMsg = 'End Date';
                }
            }

            for (let i = 0; i < this.currentRentTermDetails.Id; i++) {
                if (date < this.PropertyRentTerm[i].LeaseStartDate || date < this.PropertyRentTerm[i].LeaseEndDate) {
                    status = false;
                    overlapingRows.push(i + 1);
                }

                if (dateType == 1) //start date
                {
                    this.IsStartDateValid = !status;
                    toastMsg = 'Start Date';
                }
                else {
                    this.IsEndDateValid = !status;
                    toastMsg = 'End Date';
                }
            }

            if (this.validationService.IsDate(this.LeaseEndDate) && dateType == 1 && date > this.LeaseEndDate) {
                this.IsStartDateValid = true;
                this.Toast.addToast({ title: 'Start date should be less than End date', timeout: 10000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
            if (this.validationService.IsDate(this.LeaseStartDate) && dateType == 2 && date < this.LeaseStartDate) {
                this.IsEndDateValid = true;
                this.Toast.addToast({ title: 'End date should be greater than Start date', timeout: 10000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

            }

            if (dateType == 1 && date < this.LeaseCommencementDate && this.validationService.IsDate(date)) {
                this.IsStartDateValid = true;
                this.Toast.addToast({ title: 'Date should be greater than Lease Commencement Date', timeout: 10000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
            if (dateType == 2 && date < this.LeaseCommencementDate && this.validationService.IsDate(date)) {
                this.IsEndDateValid = true;
                this.Toast.addToast({ title: 'Date should be greater than Lease Commencement Date', timeout: 10000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

            }


            if (!status) {
                this.Toast.addToast({ title: toastMsg + " Overlaps Rows " + overlapingRows.join(","), timeout: 10000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
        }
    }

    checkFormValidation() {
        let status = false;
        if (this.Years && this.LeaseStartDate && this.LeaseEndDate && this.NetOperatingIncome) {
            status = true;
        }

        if (!this.Years) {
            this.IsValidYears = true;
        }
        if (!this.NetOperatingIncome) {
            this.IsValidNetOperatingIncome = true;
        }
        if (!this.LeaseEndDate) {
            this.IsEndDateValid = true;
        }
        if (!this.LeaseStartDate) {
            this.IsStartDateValid = true;
        }


        return this.isValidIncrease && !this.IsStartDateValid && !this.IsEndDateValid && status
    }

    yearvalidate(year) {
        if (!this.Years) {
            this.IsValidYears = true;
        }
        else {
            this.IsValidYears = false;
        }
    }

    netOperatingIncomeValidate(NetOperatingIncome) {
        if (!this.NetOperatingIncome) {
            this.IsValidNetOperatingIncome = true;
        }
        else {
            this.IsValidNetOperatingIncome = false;
        }
    }



}
